exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.pagination-container[data-v-0736bb53] {\n  background-color: #fff;\n  border: none;\n  padding-right: 0;\n  margin-top: -0.1rem;\n  border-radius: 8px;\n  padding: 0rem 0.2rem 0.1rem;\n}\n", "", {"version":3,"sources":["G:/work/BJ/广西前端框架/loit-web-component/src/components/EXPagination/index.vue"],"names":[],"mappings":";AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;CAAE","file":"index.vue","sourcesContent":[".pagination-container {\n  background-color: #fff;\n  border: none;\n  padding-right: 0;\n  margin-top: -0.1rem;\n  border-radius: 8px;\n  padding: 0rem 0.2rem 0.1rem; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0736bb53","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/EXPagination/index.vue
// module id = 468
// module chunks = 0